export default __webpack_public_path__ + "static/media/privacidad.88cad145.png";